import React from 'react'
import './App.css';
import './theme/theme.css'
import { BrowserRouter } from "react-router-dom";
import url from "./url";
import axios from 'axios';
import Loading from './components/loading/Loading';
import SideDrawer from './components/side-drawer/SideDrawer';
import Backdrop from './components/side-drawer/Backdrop';

//Notifications 1233
import 'react-notifications-component/dist/theme.css'
import { store } from 'react-notifications-component';
import ReactNotification from 'react-notifications-component'

//Json Data
import navItens from './data/navItens.json'

// Redux
import { connect } from "react-redux";
import { drawerPosistion, login } from "./redux/actions";

//Routes
import Login from './pages/system/login/Login';
import AdminRoute from './routes/admin';
import ReportsRoute from './routes/reports';
import DashboardRoutes from './routes/dashboards';
import ManagementPanelRoutes from './routes/controle-carga';
import JourneyControlRoutes from './routes/journey-control';
import OperatorRoute from './routes/operator';


class App extends React.Component {
  bodyNotify = {
    title: "",
    message: " ",
    type: "",
    insert: "top",
    container: "top-right",
    dismiss: {
      duration: 4000,
      // onScreen: true
    }
  }

  constructor(props) {
    super(props);

    this.state = {
      drawerOpen: JSON.parse(localStorage.getItem("drawer")),
      loading: false,
      redirect: false
    };
  }

  componentDidMount = () => {
    this.props.drawerPosistion(this.state.drawerOpen);
    if (localStorage.getItem("login")) {
      let loginLocale = JSON.parse(localStorage.getItem("login"));
      this.validateToken(loginLocale.token);
    }
    // store.addNotification(this.bodyNotify);
    

    
  }

  logoff = () => {
    this.setState({ toast: [], loading: true });
    axios
      .get(`${url}/v1/telemetria/admin/logoff/${this.props.token}`)
      .then(d => {
        localStorage.removeItem("login");
        this.props.login({ authenticated: false, token: undefined });
        this.setState({loading: false})
        store.addNotification({...this.bodyNotify, title: 'Logoff Realizado!', type: 'success'});
        
      })
      .catch(e => console.log(e.response));
  };

  validateToken = token => {
    console.log('aq', token)
    this.setState({ loading: true })
    setTimeout(() => {
      console.log('validar o login')
      axios
        .get(`${url}/v1/telemetria/admin/token/${token}`)
        .then(d => {
          console.log('ok', d.data);
          if (d.data.authenticated) {
            this.props.login(d.data);
          } else {
            // localStorage.removeItem("login");
          }
          this.setState({ loading: false });
        })
        .catch(e => {
          let error = e.response;
          if (!error) {
            // this.setState({
            //   toast: [{ msg: "Algo está errado!", type: "error" }],
            //   loading: false
            // });
            console.log('algo está errado')
            store.addNotification({...this.bodyNotify, title: 'Algo está Errado', type: 'danger', message: 'Se o problema persistir, entre em contato com a Telemetry.'});
            this.setState({ loading: false });
          } else if (e.response && e.response.data.errorMessage !== null) {
            e.response.data.errorMessage.forEach((d) => {
              if (d === "Sessão expirada!") {
                console.log('sessão expirada')
                localStorage.removeItem("login");
                this.props.login({ authenticated: false, token: undefined });
                this.setState({ loading: false });
                store.addNotification({...this.bodyNotify, title: 'Sessão Expirada!', type: 'danger'});
              }
            })
          }
          //this.errorLogoff(error);
        });
    }, 500);
  }

  toggleDrawer = () => {
    this.setState(prevState => { return { drawerOpen: !prevState.drawerOpen } })
    localStorage.setItem('drawer', !this.state.drawerOpen)
    this.props.drawerPosistion(!this.state.drawerOpen);
  }


  render() {
    // console.log('pos', this.props.drawerOpen)
    return (
      <BrowserRouter>
        <ReactNotification />

        {this.state.loading ? (
          <div className='app-center-loading'>
            <Loading />
          </div>
        ) : !this.props.authenticated ? (
          <Login />
        ) : (
          <div>
            <SideDrawer toggle={this.toggleDrawer} drawerOpen={this.state.drawerOpen} userData={this.props.user} navItens={navItens} logoff={this.logoff}/>
            {this.state.drawerOpen ? (<Backdrop toggle={this.toggleDrawer} />) : null}
            <div className={`App transition ${this.state.drawerOpen ? 'drawer-is-open' : ''}`}>

              {/* Routes */}
              <AdminRoute token={this.props.token} bodyNotify={this.bodyNotify} validateToken={this.validateToken}/>
              <ReportsRoute token={this.props.token} bodyNotify={this.bodyNotify} validateToken={this.validateToken}/>
              <DashboardRoutes token={this.props.token} bodyNotify={this.bodyNotify} validateToken={this.validateToken}/>
              <ManagementPanelRoutes token={this.props.token} bodyNotify={this.bodyNotify} validateToken={this.validateToken}/>
              <JourneyControlRoutes token={this.props.token} bodyNotify={this.bodyNotify} validateToken={this.validateToken}/>
              <OperatorRoute token={this.props.token} bodyNotify={this.bodyNotify} validateToken={this.validateToken}/>

            </div>
          </div>

        )}
      </BrowserRouter>
    )

  }
}

const mapStateToProps = state => {
  return {
    drawerOpen: state.drawerOpen,
    token: state.token,
    authenticated: state.authenticated,
    user: state.user,
  };
};

const mapDispatchToProps = dispatch => {
  return {
    drawerPosistion: data => dispatch(drawerPosistion(data)),
    login: data => dispatch(login(data))
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(App);
